import { render, staticRenderFns } from "./StaffMemberEditor.vue?vue&type=template&id=6d60e0f0&"
import script from "./StaffMemberEditor.vue?vue&type=script&lang=js&"
export * from "./StaffMemberEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports